var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2083 13H5.79167C5.35467 13 5 12.552 5 12C5 11.448 5.35467 11 5.79167 11H23.2083C23.6453 11 24 11.448 24 12C24 12.552 23.6453 13 23.2083 13Z",
    fill: "#1D2C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 5H1C0.447998 5 0 4.552 0 4C0 3.448 0.447998 3 1 3H23C23.552 3 24 3.448 24 4C24 4.552 23.552 5 23 5Z",
    fill: "#1D2C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20.6458H1C0.447998 20.6458 0 20.1978 0 19.6458C0 19.0938 0.447998 18.6458 1 18.6458H23C23.552 18.6458 24 19.0938 24 19.6458C24 20.1978 23.552 20.6458 23 20.6458Z",
    fill: "#1D2C4C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.e55aae13.svg";
export { ForwardRef as ReactComponent };